import React from "react";

const Contact = () => {
  return (
    <div className="about">
      <p>Contact Us;</p>
      <div class="social">
        <a href="mailto:admin@matamedia.co">
          <img src="images/download.png" alt="Facebook" />
        </a>
        <a href="https://www.facebook.com/share/1Kxf5CLzMG/" target="_blank">
          <img src="images/face.jpg" alt="Facebook" />
        </a>
        <a href="https://www.youtube.com/@MataMedia-g8y8" target="_blank">
          <img src="images/images.png" alt="YouTube" />
        </a>
        <a href="https://www.tiktok.com/@mata.media5" target="_blank">
          <img src="images/d426a19c63225966404f14cf7586e71c.jpg" alt="TikTok" />
        </a>
        <a
          href="https://www.instagram.com/matamedia__?igsh=MXkxbjl2ZHR2N2FxcA=="
          target="_blank"
        >
          <img src="images/instagram-icon_1057-2227.jpg" alt="Instagram" />
        </a>
      </div>
    </div>
  );
};

export default Contact;
